import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_TattooFontGenerator = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/tattoo-font-generator',
			name: 'AI Tattoo Font Generator — Create Custom Tattoo Lettering Online | Lift',
			description:
				'Design custom tattoo fonts with AI in seconds. No watermark. Generate script, cursive, and letter styles for names, quotes, and text online. Try now!',
			url: 'https://liftapp.ai/tattoo-font-generator',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/tattoo-font-generator#product' },
				{ '@id': 'https://liftapp.ai/tattoo-font-generator#howto' },
				{ '@id': 'https://liftapp.ai/tattoo-font-generator#benefits' },
				{ '@id': 'https://liftapp.ai/tattoo-font-generator#faq' },
				{ '@id': 'https://liftapp.ai/tattoo-font-generator#why-lift' },
				{ '@id': 'https://liftapp.ai/tattoo-font-generator#explore-tools' },
				{ '@id': 'https://liftapp.ai/tattoo-font-generator#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/tattoo-font-generator#product',
			name: 'Tattoo Font Generator',
			description:
				"Create custom tattoo fonts and lettering with AI instantly. Generate script, cursive, and name styles for any tattoo text. Try Lift's Tattoo Font Generator now!",
			url: 'https://liftapp.ai/tattoo-font-generator',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/tattoo-font-generator#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Choose your style & placement',
					text: 'Select from a range of tattoo styles and pick the exact body part where you want your tattoo',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Describe your vision',
					text: 'Write your tattoo idea in detail or keep it simple — our AI tattoo font creator understands your concept',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Add reference images',
					text: 'Upload reference photos for inspiration, and let our AI tattoo typography generator bring your vision to life.',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download your design',
					text: 'Get your AI generated tattoo instantly — ready to show your tattoo artist or save for later',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/tattoo-font-generator#benefits',
			name: "Who can benefit from Lift's Tattoo Font Generator?",
			description:
				"Lift's Tattoo Font Generator helps first-time clients, creative individuals, and anyone looking to visualize tattoo lettering designs before committing.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Tattoo font generator for first-time clients — Preview your tattoo text on the exact body placement before committing. Avoid regret and choose the right tattoo lettering style with confidence.',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Font tattoo creator for unique custom ideas — Stop using generic designs. Lift helps you create original tattoo typography tailored to your personality in seconds.',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Tattoo text font generator for clear visual references — Struggling to explain your tattoo idea to an artist? Turn your words into a clean, detailed lettering reference that makes communication easy.',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Script tattoo font generator for style testing — Not sure what works best for names, quotes, or symbols? Explore cursive and classic tattoo font styles online instantly.',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Tattoo font creator for personalized lettering — Create custom script, calligraphy, or name designs with ease — perfect for anyone looking for the best tattoo font generator.',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'Best Tattoo Font Generator for Custom Tattoo Lettering',
				description:
					'Tattoo font generator showing custom script design previewed on arm.',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/tattoo-font-generator#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift Tattoo Font Generator?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift Tattoo Font Generator is a online tool that instantly creates custom tattoo lettering and typography designs using artificial intelligence — perfect for names, quotes, script styles, and personalized text-based tattoos.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift Tattoo Font Generator work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Simply choose your preferred tattoo lettering style and body placement, describe your text or name idea, and optionally upload reference photos. Our tattoo text font generator processes your input and creates unique, personalized font designs in seconds — no design skills required.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I customize the tattoo designs generated by AI?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Absolutely! You can generate multiple font variations by adjusting your text prompt, changing lettering styles, or trying different placements. The AI font tattoo creator gives you full creative control to explore cursive, script, calligraphy, and classic styles until you find your perfect design.',
					},
				},
				{
					'@type': 'Question',
					name: 'What font styles can I create with the tattoo font generator?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift supports all popular tattoo font styles, including script, cursive, calligraphy, classic, gothic, graffiti, block letters, fine line, and handwriting styles. Our tattoo font maker is perfect for creating name tattoos, quote designs, lettering concepts, and custom typography for any body placement.',
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/tattoo-font-generator#why-lift',
			name: "Why Lift's Tattoo Font Generator stands out",
			description:
				"Lift's Tattoo Font Generator combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'Tattoo font generator showing custom script design previewed on wrist',
				description:
					"Comparison of Lift's Tattoo Font Generator benefits — professional quality, AI accuracy, multi-platform access, and cost savings.",
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/tattoo-font-generator#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/tattoo-font-generator#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Tattoo Font Generator',
					item: 'https://liftapp.ai/tattoo-font-generator',
				},
			],
		},
	],
};
